var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDumbbell = function SvgDumbbell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    fill: "none",
    viewBox: "0 0 31 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B0B0B0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.56,
    d: "m8.46 8.56 14.08 14.081m4.481 4.48-1.28-1.28M3.981 4.081l1.28 1.28M23.18 28.4l5.12-5.12m-25.6-15.36L7.82 2.8M3.98 13.04l8.96-8.96m5.12 23.04 8.96-8.96"
  })));
};
export default SvgDumbbell;